<template>
  <div>
    <image-uploader
      hidden
      :id="'imageUploader' + (owner ? owner : '')"
      :debug="1"
      :maxWidth="1080"
      :quality="0.7"
      :autoRotate="false"
      outputFormat="verbose"
      data-cy="imageUpload"
      :preview="false"
      :className="['fileinput', { 'fileinput--loaded': hasImage }]"
      accept="image/*"
      doNotResize="['gif', 'svg']"
      @input="setImage"
    ></image-uploader>
    
    <!-- Employee Image Button -->
      <v-layout v-if="customerImage" column justify-center align-center fill-height>
          <div class="text-xs-center">
            <v-menu v-model="menu" ref="menuRef" offset-y close-on-click close-on-content-click>
              <template v-slot:activator="{ on }">
                <v-layout column justify-center align-center v-on="on">
                  <v-flex>
                  <v-avatar size="120px" class="outlined-avatar">
                    <v-img :src="image" contain :aspect-ratio="setAspectRatio" />
                  </v-avatar>                
                </v-flex>
                </v-layout>
              </template>
              <v-list>
                <div v-if="!customerImage">
                <IconSelection @canceled="canceled" @selected="iconSelected" />
                <v-divider></v-divider>
                <ImageSelection @canceled="canceled" v-if="(getImages)" :images="getImages" @selected="imageSelected" />
                <v-divider></v-divider>
                </div>
                <v-list-item
                  data-cy="componentsLottieImageBoxInsertImageBtn"
                  @click="imageURL_dialog()"
                >
                  <v-list-item-title>Image URL</v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop.prevent="uploadImage() ; menu = false">
                  <v-list-item-title>Upload Image</v-list-item-title>
                </v-list-item>
                <v-divider v-if="imageURL"></v-divider>
                <v-list-item
                  data-cy="componentsLottieImageBoxRemoveBtn"
                  v-if="imageURL"
                  @click.stop.prevent="image = null; menu = false"
                >
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-dialog persistent max-width="400px" v-model="dialog">
          <v-card >
            <CardToolbar title="Add URL" :isModal="true" @cancel="dialog = false" />
            <v-card-text>
              <v-textarea
                data-cy="componentsLottieImageBoxInsertImageUrl"
                label="Image URL"
                v-model="url"
                solo
                :hide-details="urlErrors.length === 0"
                :errorMessages="urlErrors"
                @blur="$v.url.$touch()"
              ></v-textarea>
            </v-card-text>
            <CardActions name="imageBox" @submit="submitURL" @cancel="dialog = false" />
          </v-card>
        </v-dialog>
        
      </v-layout>
   

    <!-- Default Image Button -->
    <v-card text class="outlined pa-3" width="150" v-if="!customerImage">
      <v-layout column>
        <v-flex class="pa-1">
          <v-img :src="image" contain :aspect-ratio="setAspectRatio"></v-img>
        </v-flex>
        <v-flex shrink class="pa-1" >
          <div class="text-xs-center">
            <v-menu v-model="menu" ref="menuRef" offset-y close-on-click close-on-content-click>
              <template v-slot:activator="{ on }">
                <v-btn v-if="stateID" data-cy="componentsLottieImageBoxActionBtn" color="primary" dark v-on="on">
                 Add State ID
                </v-btn>
                <v-btn v-else data-cy="componentsLottieImageBoxActionBtn" color="primary" dark v-on="on">
                  Action
                </v-btn>
              </template>
              <v-list>
                <div v-if="!stateID">
                <IconSelection @canceled="canceled" @selected="iconSelected" />
                <v-divider></v-divider>
                <ImageSelection @canceled="canceled" v-if="(getImages)" :images="getImages" @selected="imageSelected" />
                <v-divider></v-divider>
                </div>
                <v-list-item
                  @click.stop.prevent="imageURL_dialog()"
                >
                  <v-list-item-title>Image URL</v-list-item-title>
                </v-list-item>
                <v-list-item @click.stop.prevent="uploadImage() ; menu = false">
                  <v-list-item-title>Upload Image</v-list-item-title>
                </v-list-item>
                <v-divider v-if="imageURL"></v-divider>
                <v-list-item
                  v-if="imageURL"
                  @click.stop.prevent="image = null; menu = false"
                >
                  <v-list-item-title>delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-flex>

        <v-dialog persistent max-width="400px" v-model="dialog">
          <v-card >
            <CardToolbar title="Add URL" :isModal="true" @cancel="dialog = false" />
            <v-card-text>
              <v-textarea
                data-cy="componentsLottieImageBoxInsertImageUrl"
                label="Image URL"
                v-model="url"
                solo
                :hide-details="urlErrors.length === 0"
                :errorMessages="urlErrors"
                @blur="$v.url.$touch()"
              ></v-textarea>
            </v-card-text>
            <CardActions name="imageBox" @submit="submitURL" @cancel="dialog = false" />
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
import settingService from '@/modules/Settings/service.js';
import IconSelection from '@/components/IconSelection.vue'
import ImageSelection from '@/components/Image/ImageSelection.vue';

const stateIdPlaceholder = require('@/assets/images/user.jpeg');
const imagePlaceholder = require('@/assets/images/photo.png');
const { validationMixin } = require('vuelidate');
const { url } = require('vuelidate/lib/validators');

export default {
  name: 'image-box',
  props: ['imageURL', 'owner', 'uploadOnly', 'images', 'smallBox', 'stateID', 'customerImage'],
  data() {
    return {
      id: null,
      dialog: false,
      hasImage: false,
      url: null,
      menu: false,
      aspectRatio: '1.3333',
    };
  },
  components: {
		IconSelection,
		ImageSelection,
  },
  computed: {
    setAspectRatio() {
      if (this.smallBox) {
        return '1.8888';
      } else return '1.3333';
    },
    urlErrors() {
      const errors = [];
      if (!this.$v.url.$dirty) return errors;
      if (!this.$v.url.url) errors.push(this.$t('validations.notValidURL'));

      return errors;
		},
		getImages() {
			return this.images
		},
    defaultPlaceholder() {
      if (this.stateID || this.customerImage) return stateIdPlaceholder;
      else return imagePlaceholder; 
    },
    iconImage() {
      if (this.customerImage) return 
    },
    image: {
      get() {
        if (this.imageURL) return this.imageURL;
        return this.defaultPlaceholder;
      },
      set(val) {
        if (val) {
          //alert(Object.values(val));
          return settingService
            .uploadMedia(val)
            .then(response => {
              console.log('response', response)
              this.$emit('setImage', response.data.url);
            })
            .catch(error => {
              console.log(error);
            });
        }
        this.$emit('setImage', null);
      },
    },
  },
  methods: {
    imageURL_dialog() {
      this.dialog = true;
      this.menu = false;
    },
		imageSelected(item) {
      this.$refs.menuRef.isActive = false;
      this.$emit('setImage', item);
		},
    iconSelected(item) {
      this.$refs.menuRef.isActive = false;
      this.$emit('setImage', item.url);
    },
    canceled(val) {
      this.$refs.menuRef.isActive = val;
    },
    setImage(file) {
      this.hasImage = true;
      this.image = file;
    },
    uploadImage() {
      console.log(`imageUploader${this.owner ? this.owner : ''}`);
      console.log('image file', this.image);
      console.log(document.getElementById('imageUploader'));
      document.getElementById(`imageUploader${this.owner ? this.owner : ''}`).click();
    },
    submitURL() {
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
        
      } else {
        // var element = {}
        // element['url'] =  this.url;     
        this.dialog = false;
        this.$emit('setImage', this.url);
      }
    },
  },
  mixins: [validationMixin],
  validations: {
    url: {
      url,
    },
  },
};
</script>

<style scoped>
.deleteBtn {
  margin-top: -30px !important;
  margin-left: -35px !important;
}
</style>
